import React from 'react';
import { IChildConnectionDTO } from '../../../../../../api/connections.dao';
import TextWithCopyBtn from '../../connections-list/_text-with-copy-btn/text-with-copy-btn';
import { childConnectionDetailsLabels } from '../../../../../../constants/connections-labels.constants';

type UniqueJoiningLinkDetailsProps = {
    childConnection: IChildConnectionDTO;
    onCopyBtnClick: () => void;
};

export const UniqueJoiningLinkDetails = (props: UniqueJoiningLinkDetailsProps): JSX.Element => {
    const { childConnection, onCopyBtnClick } = props;
    const { attendeeEmail, attendeeId, connectionLink, parentConnectionId } = childConnection;
    const labels = childConnectionDetailsLabels();
    const connectionTypeLabel = 'Unique Link';

    return (
        <>
            {attendeeEmail && (
                <div className='connection-list__field'>
                    {connectionTypeLabel} {labels.ATTENDEE_EMAIL()}:<br />
                    <TextWithCopyBtn message={attendeeEmail} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
            {attendeeId && (
                <div className='connection-list__field'>
                    {connectionTypeLabel} {labels.ATTENDEE_ID()}:<br />
                    <TextWithCopyBtn message={String(attendeeId)} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
            {connectionLink && (
                <div className='connection-list__field'>
                    {connectionTypeLabel} {labels.CONNECTION_LINK()}:<br />
                    <TextWithCopyBtn message={connectionLink} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
            {parentConnectionId && (
                <div className='connection-list__field'>
                    {connectionTypeLabel} {labels.CONNECTION_ID()}:<br />
                    <TextWithCopyBtn message={String(parentConnectionId)} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
        </>
    );
};
